/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ shown: NonNullable<unknown>, total: NonNullable<unknown> }} Notificationcenter_Countshown2Inputs */

const en_notificationcenter_countshown2 = /** @type {(inputs: Notificationcenter_Countshown2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Showing ${i?.shown} of ${i?.total}`)
};

/**
* | output |
* | --- |
* | "Showing {shown} of {total}" |
*
* @param {Notificationcenter_Countshown2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const notificationcenter_countshown2 = /** @type {((inputs: Notificationcenter_Countshown2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notificationcenter_Countshown2Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_notificationcenter_countshown2(inputs)
});
export { notificationcenter_countshown2 as "notificationCenter_countShown" }